import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import Config from '../../../Config';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers.js';
import {isMobile} from 'react-device-detect';
import Lottie from 'react-lottie';
import esimAnimation from './eSIM_Banner.json';
//import esimAnimation from './eSIM_Banner_Small.json';
const StripBannerBlock = (props) => {
  useEffect(() => {
    if (animationType === 0) {
      //do not show animation
      return setShowAnimation(false);
    }
    if (animationType === 1) {
      //ESIM ANIMATION
      setAnimationFile(esimAnimation);
      setShowAnimation(true);
      return;
    }
  }, []);

  const epiBaseUrl = Config?.epiBaseUrl;
  const backGroundDesktopImage = epiBaseUrl + props.iContent.backGroundDesktopImage.value?.url;
  const backGroundMobileImage = epiBaseUrl + props.iContent.backGroundMobileImage.value?.url;
  const backGroundColorBtn = props.iContent.backGroundColorBtn?.value;
  const backGroundColorBtnLeft = props.iContent.backGroundColorBtnLeft?.value;
  const textColorBtn = props.iContent.textColorBtn?.value;
  const textColorBtnLeft = props.iContent.textColorBtnLeft?.value;
  const animationType = props.iContent.animationType?.value;

  const [showAnimation, setShowAnimation] = useState(false);
  const [animationFile, setAnimationFile] = useState('');

  const onClick = () => {
    if (props.onClick) {
      props.onClick();
    } else {
      var navigationPageLink = props.iContent.navigationPageLink?.value;
      if (navigationPageLink === null) {
        var url = props.iContent.navigationScroll?.value;
        var scrollId = document.getElementById(url);
        scrollId.scrollIntoView({behavior: 'smooth'}, true);
      } else {
        prepareUrl(navigationPageLink, props.context);
      }
    }
  };

  const onClickLeft = () => {
    var navigationPageLink = props.iContent.navigationPageLinkLeft?.value;
    if (navigationPageLink === null) {
      var url = props.iContent.navigationScrollLeft?.value;
      var scrollId = document.getElementById(url);
      scrollId.scrollIntoView({behavior: 'smooth'}, true);
    } else {
      prepareUrl(navigationPageLink, props.context);
    }
  };

  return (
    <>
      <div className={'strip-banner-content-main'}>
        <Image className='background' src={isMobile ? backGroundMobileImage : backGroundDesktopImage} />
        {/* {
                    showAnimation &&
                    <div className='strip-banner-content-layer2img'>
                        <Lottie options={{ animationData: animationFile, loop: true, autoplay: true }} width={400} height={335} />
                    </div>
                } */}

        <div className='strip-banner-content-header'>
          <div
            className='strip-banner-content-title'
            dangerouslySetInnerHTML={{__html: isMobile ? props.iContent.mainTitleMobile?.value : props.iContent.mainTitle?.value}}></div>

          <div
            className='strip-banner-content-sub-title'
            dangerouslySetInnerHTML={{__html: isMobile ? props.iContent.subTitleMobile?.value : props.iContent.subTitle?.value}}></div>

          <div className='strip-banner-content-btn-container'>
            {props.iContent.textBtn?.value.length > 0 && (
              <button
                onClick={() => onClick()}
                className='strip-banner-content-btn'
                style={{backgroundColor: `${backGroundColorBtn}`, color: `${textColorBtn}`}}>
                {props.iContent.textBtn?.value}
              </button>
            )}
            {props.iContent.textBtnLeft?.value.length > 0 && (
              <button
                onClick={() => onClickLeft()}
                className='strip-banner-content-btn'
                style={{backgroundColor: `${backGroundColorBtnLeft}`, color: `${textColorBtnLeft}`}}>
                {props.iContent.textBtnLeft?.value}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default StripBannerBlock;
